"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function GetStartedCta() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section ref={ref} className="bg-light-background py-16 md:py-24">
      <div className={`
          mx-auto max-w-4xl px-6 text-center
          transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)]
          ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}
        `}>
        <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
          Start Your Child's Journey Today
        </h2>
        <p className="text-muted-foreground text-base md:text-lg mb-8 max-w-2xl mx-auto">
          Book a free consultation and discover how our expert tutors and confidence coaching can help your child thrive academically and personally.
        </p>
        <Link to="/ContactPage">
          <Button size="lg" className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive text-primary-foreground shadow-xs h-10 rounded-md px-6 has-[>svg]:px-4 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] !bg-[hsl(86,78%,27%)] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-primary/90 hover:-translate-y-0.5 hover:shadow-medium">
            Book a Free Consultation
          </Button>
        </Link>
      </div>
    </section>;
}